import { Box, Button, Typography } from "@mui/material";
import { NickCarTypeList } from "../../constants/crime";
import { CrimeType } from "../../types/CrimeType";

import useStyles from "./index.styles";
import { useAppSelector } from "../../app/hooks";
import { getSuccessRate } from "./helper/nickCar";
import { toUSDFormat } from "../../utils/utils";

const NickCarListItem = ({
  rankNumber,
  onAttempt,
  disabled,
  crime,
}: {
  rankNumber: number;
  crime: CrimeType;
  onAttempt: (crimeType: number) => void;
  disabled: boolean;
}) => {
  const { classes } = useStyles();
  const successRate = getSuccessRate(rankNumber, crime.id);
  const handleAttempt = () => {
    if (!disabled) {
      onAttempt(crime.id);
    }
  };

  return (
    <Box className={classes.nickcarListItem}>
      <Typography className={classes.crimeTitle}>{crime.title}</Typography>
      <Box
        component="img"
        src={crime.image}
        alt={crime.title}
        className={classes.crimeImage}
      />

      <Box className={classes.crimeListItemFooter}>
        <Box className={classes.crimeListItemFooterText}>
          <Typography className={classes.successChanceText}>
            {toUSDFormat(successRate)}%
          </Typography>
          <Typography className={classes.successChanceLabelText}>
            Success chance
          </Typography>
        </Box>

        <Button
          variant="contained"
          className={classes.attemptButton}
          onClick={handleAttempt}
          disabled={disabled}
        >
          Attempt now
        </Button>
      </Box>
    </Box>
  );
};

const NickCarList = ({
  handleAttempt,
  disabled,
}: {
  handleAttempt: (crimeType: number) => void;
  disabled: boolean;
}) => {
  const { classes } = useStyles();
  const { myProfile } = useAppSelector((state) => state.profile);
  return (
    <Box className={classes.nickcarList}>
      {NickCarTypeList.map((crime, index) => (
        <NickCarListItem
          rankNumber={myProfile.rankNumber || 1}
          crime={crime}
          key={index}
          onAttempt={handleAttempt}
          disabled={disabled}
        />
      ))}
    </Box>
  );
};

export default NickCarList;
